var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3C14.8945 3 14 3.89453 14 5C14 5.08594 14.0195 5.16797 14.0312 5.25C10.5742 6.13281 8 9.27344 8 13V22C8 22.5664 7.56641 23 7 23H6V25H13.1875C13.0742 25.3164 13 25.6484 13 26C13 27.6445 14.3555 29 16 29C17.6445 29 19 27.6445 19 26C19 25.6484 18.9258 25.3164 18.8125 25H26V23H25C24.4336 23 24 22.5664 24 22V13.2812C24 9.52344 21.4883 6.17188 17.9688 5.25C17.9805 5.16797 18 5.08594 18 5C18 3.89453 17.1055 3 16 3ZM15.5625 7C15.707 6.98828 15.8516 7 16 7C16.0625 7 16.125 7 16.1875 7C19.4531 7.09766 22 9.96094 22 13.2812V22C22 22.3516 22.0742 22.6836 22.1875 23H9.8125C9.92578 22.6836 10 22.3516 10 22V13C10 9.82422 12.4453 7.22656 15.5625 7ZM16 25C16.5625 25 17 25.4375 17 26C17 26.5625 16.5625 27 16 27C15.4375 27 15 26.5625 15 26C15 25.4375 15.4375 25 16 25Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 3,
    r: 3,
    fill: "#7A0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellicon);
export default __webpack_public_path__ + "static/media/bellicon.709f1e7451da5bb43e4200cda2d0cfba.svg";
export { ForwardRef as ReactComponent };